<div class="flex min-h-[420px] flex-col justify-center rounded-lg bg-white p-8 dark:bg-night-700">
  @if (this.isHighcharts) {
  <highcharts-chart
    #chart
    [Highcharts]="Highcharts"
    [options]="chartOptions"
    style="width: 100%; height: 350px; display: block">
  </highcharts-chart>
  } @if(this.liveStatus){
  <!-- Header de la tabla -->
  <div class="mt-12 flex bg-gray-100 dark:bg-night-800">
    <div class="flex-1 p-2 text-sm font-bold text-gray-700 dark:text-night-50">
      <i class="pi pi-arrow-circle-up"></i> U Speed
    </div>
    <div class="flex-1 p-2 text-sm font-bold text-gray-700 dark:text-night-50">
      {{ this.liveStatus.extra_data.upload }}
    </div>
    <div class="flex-1 p-2 text-sm font-bold text-gray-700 dark:text-night-50">Max</div>
    <div class="flex-1 p-2 text-sm font-bold text-gray-700 dark:text-night-50">
      {{ this.liveStatus.extra_data.uploadpeak }}
    </div>
    <div class="flex-1 p-2 text-sm font-bold text-gray-700 dark:text-night-50">Psp</div>
    <div class="flex-1 p-2 text-sm font-bold text-gray-700 dark:text-night-50">
      {{ this.liveStatus.extra_data.uploadpps }}
    </div>
  </div>

  <!-- Fila 1 -->
  <div class="flex border-t border-gray-300 dark:border-night-600">
    <div class="flex-1 p-2 text-sm text-gray-600 dark:text-night-200">
      <i class="pi pi-arrow-circle-down"></i> D Speed
    </div>
    <div class="flex-1 p-2 text-sm text-gray-600 dark:text-night-200">
      {{ this.liveStatus.extra_data.download }}
    </div>
    <div class="flex-1 p-2 text-sm text-gray-600 dark:text-night-200">Max</div>
    <div class="flex-1 p-2 text-sm text-gray-600 dark:text-night-200">
      {{ this.liveStatus.extra_data.downloadpeak }}
    </div>
    <div class="flex-1 p-2 text-sm text-gray-600 dark:text-night-200">Psp</div>
    <div class="flex-1 p-2 text-sm text-gray-600 dark:text-night-200">
      {{ this.liveStatus.extra_data.uploadpps }}
    </div>
  </div>

  }
</div>
